import { render, staticRenderFns } from "./BasePaginatorHoc.vue?vue&type=template&id=389b6c50&"
import script from "./BasePaginatorHoc.vue?vue&type=script&lang=ts&"
export * from "./BasePaginatorHoc.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports